// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "9c66d7257db74150","396": "80fce5b5ffbf5227","460": "33b6df7385df1672","498": "378210625f81d1fb","917": "fcc735bcaae9450b","985": "cfffc661c5d1ac86",}[chunkId] + ".chunk.js"
}